import Serializable from './serializable';

export class Feedback extends Serializable {
	id: string;
	time: number;
	userId: string;
	userName: string;
	userEmail: string;
	type: number;
	comment: string;
	gameId: string;
	gameName: {};
	missionId: string;
	missionName: {};
	teamId: string;
	teamName: string;
	pictures: string[];
	status: string; // 'new' (empty/null), 'read', 'archived'
}
